// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\TopicCardAvailableAttachment\ApiTopicCardAvailableAttachment.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { TopicCard, TopicCardData, TopicCardOptions } from 'data/models/TopicCard';

// TopicCardAvailableAttachmentData is the class that TopicCardAvailableAttachment serializes to/from
export interface TopicCardAvailableAttachmentData {
    Id : number;
	
    AttachmentUrl : string;
    Card : TopicCardData | null;
    CardId : number;
	
    DisplayOrder : number;
}

// TopicCardAvailableAttachmentOptions is the class which may be passed to the TopicCardAvailableAttachment constructor to define optional initial data values
export interface TopicCardAvailableAttachmentOptions {
    Id : number;
	
    AttachmentUrl? : string;
    Card? : TopicCardOptions | null;
    CardId? : number;
	
    DisplayOrder? : number;
}

export class TopicCardAvailableAttachment {
    public Id : DataSignal<number>;
	
    public AttachmentUrl : DataSignal<string>;
    public Card : DataSignal<TopicCard | null>;
    public CardId : DataSignal<number>;
	
    public DisplayOrder : DataSignal<number>;

    constructor();
    constructor(data : TopicCardAvailableAttachmentOptions);
    constructor(data: TopicCardAvailableAttachmentOptions | null = null) {
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
	    
        this.AttachmentUrl = jsonableObservable(S.value<string>(data && data.AttachmentUrl !== undefined ? data.AttachmentUrl : ''));
        this.Card = S.value<TopicCard | null>(null);
        this.CardId = jsonableObservable(S.value<number>(data && data.CardId !== undefined ? data.CardId : 0));
	    
        this.DisplayOrder = jsonableObservable(S.value<number>(data && data.DisplayOrder !== undefined ? data.DisplayOrder : 0));
    }

    static key(obj : TopicCardAvailableAttachment) {
        return obj.Id();
    }
    
    static dataKey(obj : TopicCardAvailableAttachmentOptions) {
        return obj.Id;
    }

    static update(obj : TopicCardAvailableAttachment, data : TopicCardAvailableAttachmentOptions) {
        S.freeze(() => {
            if (data.Id !== undefined) obj.Id(data.Id);
	        
            if (data.AttachmentUrl !== undefined) obj.AttachmentUrl(data.AttachmentUrl);
            if (data.CardId !== undefined) obj.CardId(data.CardId);
	        
            if (data.DisplayOrder !== undefined) obj.DisplayOrder(data.DisplayOrder);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/TopicCardAvailableAttachment.ts